export enum UploadProcessStatus {
  PROCESSING = 'Processing',
  FAILED = 'Failed',
  SUCCESS = 'Success',
}
